module.exports = "<p>\n  terms works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/terms/terms.component.html
// module id = ./src/app/terms/terms.component.html
// module chunks = main